const crmTranslation = {
  mode: 'ko',
  menu: 'CRM',

  crm: 'CRM 기록',
  cs: 'CS',
  channelTalkRequests: '채널톡 요청',
  detail: '상세 기록',
  crmTitle: 'CRM 내역',
  crmTypeTitle: 'CRM 유형 관리',
  sendTaChannel: '기술 지원 채널에 알림',
  addCrm: '기록 추가',
  editCrm: '기록 수정',
  deleteCrm: '기록 삭제',
  slackLink: '슬랙 링크',
  manageType: '유형 관리',
  addType: '유형 추가',
  searchType: '유형 이름 검색',
  selectType: '유형 선택',
  selectStatus: '상태 선택',
  insertDescription: '내용 입력',
  sendSlack: '슬랙에 메시지 전송',

  seq: '번호',
  hospital: '병원',
  hospitalName: '병원명',
  unassignedHospital: '병원 미지정',
  hospitalRoom: '진료실',
  type: '유형',
  typeName: '유형 이름',
  crmStatus: '처리 상태',
  orderedAt: '생성 일시',
  updatedAt: '수정 일시',
  actor: '처리자',
  description: '내용',
  processing: '진행중',
  keep: '보류',
  complete: '종료',
  archive: '보관',
  actions: '작업',
  approve: '승인',
  manualComplete: '완료',
  rollback: '작업 취소',
  bulkApprove: '일괄 승인',
  reject: '거절',
  detailReview: '검토',
  detailView: '상세 보기',
  saveReview: '검토 저장',
  editField: '값 수정',
  viewOriginalData: '원본 데이터 보기',
  conversationSectionTitle: '대화 기록',
  requestDetailsSectionTitle: '요청 관련 데이터',
  processingDetailsSectionTitle: '처리 내역',
  recordingDetailsSectionTitle: '영상 데이터',
  recordingSelectionTitle: '영상 선택',
  hospitalSelectionTitle: '병원 선택',
  roomSelectionTitle: '병실 선택',
  recordingSearchPlaceholder: '바코드, 영상 번호, 병실명으로 검색',
  selectHospitalFirst: '병원을 먼저 선택해주세요.',
  noHospitalRooms: '병실 없음',
  conversationInputLabel: '병원에 보낼 메시지',
  conversationInputPlaceholder: '추가로 확인이 필요한 내용을 입력하세요.',
  sendConversationMessage: '메시지 전송',
  requestMessage: '요청 메시지',
  rollbackReason: '작업 취소 사유',
  barcodeLookup: '바코드 검증',
  barcodeLookupDescription: '입력한 바코드로 영상 목록과 통합CS 유저 정보를 다시 확인합니다.',
  barcodeLookupUserInfo: '통합CS 유저 정보',
  barcodeLookupRecordings: '영상 목록',
  userInfoName: '성명',
  userInfoSeq: '유저 번호',
  userInfoPhone: '전화번호',
  userInfoBabies: '아이 정보',
  videoLengthLabel: '영상 길이',
  editDurationPlaceholder: '예: 3분 27초까지',
  yes: '예',
  no: '아니오',
  channelTalkDetailTitle: '채널톡 요청 상세',
  channelTalkReviewTitle: '요청 검토',
  channelTalkRejectTitle: '채널톡 요청 거절',
  channelTalkApproveDecisionTitle: '승인 확인',
  channelTalkCompleteDecisionTitle: '수동 완료 확인',
  channelTalkBulkApproveDecisionTitle: '일괄 승인 확인',
  channelTalkRejectReason: '거절 사유',
  channelTalkRejectResponseMessage: '채널톡 발송 메시지',
  channelTalkMessageDecisionLabel: '채널톡 메시지 전송 여부',
  channelTalkApproveDecisionDescription:
    '승인 처리와 함께 아래 완료 메시지를 전송할지 선택해주세요.',
  channelTalkCompleteDecisionDescription:
    '수동 완료 처리와 함께 채널톡 메시지 전송 여부를 선택해주세요.',
  channelTalkBulkApproveDecisionDescription:
    '선택한 {{count}}건을 일괄 승인합니다. 채널톡 메시지 전송 여부를 선택해주세요.',
  channelTalkResponseMessagePreviewLabel: '전송 예정 메시지',
  channelTalkSendMessageQuestion: '메시지를 전송하시겠습니까?',
  sendResponseMessage: '메시지 전송',
  skipResponseMessage: '메시지 미전송',

  channelTalkStatus: {
    pending: '대기',
    executing: '실행중',
    executed: '완료',
    rejected: '거절',
    failed: '실패',
  },

  channelTalkWorkflow: {
    transfer: '이전',
    delete: '삭제',
    edit: '편집',
  },

  channelTalkExecutionMode: {
    auto: '자동',
    review: '검토',
  },

  channelTalkProcess: {
    requestReceived: '요청 접수',
    reviewInProgress: '검토',
    additionalConversation: '추가 정보 대화',
    additionalWaiting: '추가 정보 대기',
    waitingReply: '병원 회신 대기',
    replyReceived: '병원 회신 확인 필요',
    finalize: '최종 처리',
    executed: '최종 승인',
    rejected: '거절 완료',
    failed: '처리 실패',
  },

  channelTalkProcessSummary: {
    idle: '필요하면 이 화면에서 병원에 추가 정보를 요청하고 응답을 이어서 확인할 수 있습니다.',
    waitingReply: '추가 정보 요청을 보낸 상태이며 병원 회신을 기다리는 중입니다.',
    replyReceived: '병원 회신이 도착했습니다. 내용을 확인하고 최종 처리해 주세요.',
    executed: '최종 처리가 완료되었습니다.',
    rejected: '요청이 거절되었습니다.',
    failed: '처리 실패 상태입니다.',
  },

  channelTalkFilters: {
    status: '상태',
    workflowType: '요청 유형',
    executionMode: '실행 모드',
    search: '병원명, 사용자명, 바코드 검색',
  },

  channelTalkColumns: {
    status: '상태',
    workflowType: '요청 유형',
    executionMode: '실행 모드',
    hospitalName: '병원명',
    hospitalRoomName: '병실명',
    userName: '사용자명',
    barcode: '바코드',
    sourceBarcode: '원본 바코드',
    targetBarcode: '대상 바코드',
    recordedAt: '촬영 일시',
    summary: '검토/결과 요약',
    decisionBy: '처리자',
    createdAt: '생성 일시',
    requestedAt: '요청 시각',
    recordingSeq: '영상 번호',
    reviewReason: '검토 사유',
    resultMessage: '처리 결과',
    editDuration: '편집 구간',
    decisionAt: '결정 일시',
    executedAt: '실행 일시',
    messageSentFlag: '응답 전송 여부',
    responseMessageSentAt: '응답 전송 시각',
    responseMessageText: '응답 메시지',
    slackInfo: 'Slack 메시지 정보',
    userChatId: '채널톡 채팅 ID',
    submitData: '원본 제출 데이터',
    originalRequestData: '요청 데이터',
    processedAt: '처리 일시',
  },

  channelTalkSnapshot: {
    statusCompareTitle: '상태 비교 보기',
    changeListTitle: '변경 내용',
    fullStateToggle: '전체 상태 펼쳐 보기',
    requestValue: '요청 시점',
    currentValue: '현재 상태',
    savedValue: '수정값',
    noChanges: '변경된 항목이 없습니다.',
    capturedAt: '기록 시각',
    requestStateTitle: '요청 시점 상태',
    currentStateTitle: '현재 상태',
    savedReviewTitle: '저장된 검토값',
    sourceState: '원본 영상 상태',
    targetState: '대상 영상 상태',
    targetValueState: '대상 바코드/영상',
    locationState: '병원/진료실',
    decisionState: '판단',
    currentExecutable: '현재 기준 승인 가능',
    manualCompletionDetected: '외부 수동 처리 감지',
    manualCompletionDetectedValue: '수동 처리 흔적 확인',
    manualCompletionChip: '수동 처리 감지',
    rollbackChip: '롤백 가능',
    currentReviewReason: '현재 기준 검토 사유',
  },

  channelTalkWorkBadge: {
    delete: '삭제',
    edit: '편집',
  },

  channelTalkMessages: {
    approveSuccess: '요청을 승인했습니다.',
    approveFailed: '승인 처리에 실패했습니다.',
    completeSuccess: '요청을 수동 완료 처리했습니다.',
    completeFailed: '수동 완료 처리에 실패했습니다.',
    rejectSuccess: '요청을 거절했습니다.',
    rejectFailed: '거절 처리에 실패했습니다.',
    reviewRequired: '현재는 승인할 수 없습니다. 상세 검토 내용을 확인 부탁드립니다.',
    reviewSaveSuccess: '상세 검토 내용을 저장했습니다.',
    reviewSaveFailed: '상세 검토 저장에 실패했습니다.',
    rollbackSuccess: '작업 취소 후 재검토 상태로 되돌렸습니다.',
    rollbackFailed: '작업 취소에 실패했습니다.',
    rollbackUnavailable: '현재 상태에서는 작업 취소를 지원하지 않습니다.',
    rollbackDescription:
      '이 작업을 취소하면 영상 상태를 가능한 범위에서 되돌리고, 요청을 다시 검토 대기 상태로 전환합니다.',
    rollbackReasonRequired: '작업 취소 사유를 입력해주세요.',
    rollbackReasonPlaceholder: '예: 잘못된 수동 처리라 원복 후 재검토 필요',
    barcodeLookupFailed: '바코드 검증 정보를 불러오지 못했습니다.',
    noMatchedRecording: '요청 정보와 일치하는 영상이 없습니다.',
    movedToTarget: '대상 바코드 상태로 이동됨',
    noConversationAvailable:
      '채널톡 채팅 ID가 없어 대화 기록을 불러오거나 메시지를 보낼 수 없습니다.',
    noConversationHistory: '표시할 대화 기록이 없습니다.',
    sendConversationSuccess: '메시지를 전송했습니다.',
    sendConversationFailed: '메시지 전송에 실패했습니다.',
    conversationMessageRequired: '전송할 메시지를 입력해주세요.',
    conversationSendUnavailable: '현재 요청에서는 메시지 전송이 비활성화되어 있습니다.',
    noUserInfo: '통합CS 유저 정보를 찾지 못했습니다.',
    noRecordingCandidates: '요청 정보와 일치하는 영상이 없습니다.',
    editDurationRecordingRequired: '편집 구간을 수정하려면 먼저 영상을 선택해주세요.',
    editDurationRecordingLoadFailed: '편집 대상 영상을 불러오지 못했습니다.',
    editDurationInvalidRange: '저장할 편집 구간을 다시 확인해주세요.',
    defaultRejectResponse:
      '안녕하세요, 선생님!\n\n요청 내용을 확인했지만 현재는 처리해드리기 어려워 추가 확인이 필요합니다.\n불편하시겠지만 내용을 다시 확인하신 후 재문의 부탁드립니다.\n\n감사합니다.',
    bulkApproveSuccess: '{{count}}건을 승인했습니다.',
    bulkApproveFailed: '일괄 승인에 실패했습니다.',
    bulkApprovePartial: '성공 {{successCount}}건 / 실패 {{failureCount}}건',
    closedConversationCompleted: '대화가 종료되어 완료처리 됐습니다',
    closedConversationReviewAction: '요청 검토',
    currentStatusRefreshFailed: '현재 상태를 업데이트하지 못했습니다.',
  },

  workflowRequirement: {
    requestValue: '요청 원본',
    savedValue: '현재 상태',
    supportInfo: '상세 정보',
    videoLabel: '영상',
    videoDescription: '요청 원본 데이터를 기준으로 영상을 찾고 영상 번호를 선택합니다.',
    videoFind: '영상 찾기',
    videoChange: '영상 변경',
    sourceBarcodeChange: '바코드 변경',
    targetBarcodeLabel: '대상 바코드',
    targetBarcodeDescription: '대상 바코드를 검증한 뒤 저장하면 이전 실행이 가능합니다.',
    targetBarcodeVerify: '바코드 검증',
    targetBarcodeChange: '대상 바코드 변경',
    editRangeLabel: '편집 시점',
    editRangeDescription: '영상이 정해지면 요청 문구를 기준으로 편집 구간을 설정합니다.',
    editRangeSet: '편집 구간 설정',
    editRangeChange: '편집 구간 변경',
    editPointChange: '편집 시점 변경',
    currentBarcodeLabel: '현재 바코드',
    currentVideoLengthLabel: '현재 영상 길이',
    deleteFlagLabel: '삭제 상태',
    deleteFlagDeleted: '삭제됨',
    deleteFlagActive: '정상',
    configuredEditRangeLabel: '설정 편집 시점',
    restoreAction: '롤백',
    restoreFailed: '원본 값으로 되돌리지 못했습니다.',
    summary: {
      transfer: '영상과 대상 바코드만 해결하면 이전 실행이 가능합니다.',
      edit: '영상과 편집 시점만 해결하면 편집 실행이 가능합니다.',
      delete: '영상만 찾으면 삭제 실행이 가능합니다.',
    },
    reviewRequiredTitle: '검토가 필요한 항목이 남아 있습니다.',
    status: {
      unresolved: '검토 필요',
      selected: '검토 완료',
      needsVerification: '검토 필요',
      valid: '검토 완료',
      needsSetup: '검토 필요',
      configured: '검토 완료',
    },
  },

  crmDownload: 'CRM 내역 다운로드',
  crmExcel: 'MDA-CRM_내역.xlsx',

  deleteMessage: '번 CRM 내역을 삭제하시겠습니까?',
  deleteTypeMessage: '유형을 삭제하시겠습니까?',
};

export default crmTranslation;
